import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShieldIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.87503 3.26921V9.6142C1.87504 11.6198 2.48279 13.5782 3.61816 15.2314C4.75353 16.8846 6.36321 18.155 8.23503 18.875L9.10255 19.2084C9.68022 19.4306 10.3198 19.4306 10.8976 19.2084L11.7651 18.875C13.6369 18.155 15.2466 16.8846 16.3819 15.2314C17.5173 13.5782 18.1251 11.6198 18.1251 9.6142V3.26921C18.1266 3.03045 18.0592 2.79631 17.9309 2.59495C17.8026 2.3936 17.6188 2.2336 17.4017 2.13421C15.0682 1.11571 12.546 0.601429 10.0001 0.625046C7.45408 0.601429 4.93183 1.11571 2.59836 2.13421C2.38126 2.2336 2.19749 2.3936 2.06918 2.59495C1.94085 2.79631 1.87344 3.03045 1.87503 3.26921Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 11.875C9.82742 11.875 9.6875 11.7351 9.6875 11.5625C9.6875 11.3899 9.82742 11.25 10 11.25",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 11.875C10.1726 11.875 10.3125 11.7351 10.3125 11.5625C10.3125 11.3899 10.1726 11.25 10 11.25",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 9.375V5.625",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgShieldIcon;
